import styled from "@emotion/styled";
export const StyledGalleryContainer = styled.div`
position: relative;
width: 100%;
left: -30px;
/* height: 100vh; */
`;

export const StyledCard = styled.img`
position: absolute;
border-radius: 4.40px;
width: ${props => props.width}px;
height: ${props => props.height}px;
top: ${props => props.top}px;

@media (max-width: 1040px) {
    height: auto;
    width: auto;
} 

@media (max-width: 460px) {
    //margin: 30px 30px;
    top: 0px;
    align-self: center;
    height: auto;
    // width: 200px;
}      
    @media (max-width: 335px) {
    margin: 40px 40px;
    top: 0px;
    align-self: center;
    height: auto;
    width: 200px;
}           
`;
export const ChanceCardContainer = styled.div`
        display: flex;
        width: 100%;
        max-width: 384px;
        height: 100%;
        min-height: 600px;
        align-items: center;
        justify-content: space-between;
        border-width: 1px;
        border-radius: 16px;
        padding-top: 32px;
        padding-right: 16px;
        padding-bottom: 32px;
        padding-left: 16px;
        border: 1px solid #ffffff80;
        @media (max-width: 900px) {
        width: 100%;
        }
    `;

export const StyledPhoneImage = styled.img`
        width: 100%;
        max-width: 206px;
        height: 226px;
        object-fit: cover;
    `;

export const StyledChanceCardContainer = styled(ChanceCardContainer)`
        display: flex;
        width: 384px;
        min-height: 600px;
        padding: 32px 16px;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        @media (max-width: 900px) {
        height: auto;
        }
`;

export const StyledChanceCardDiv = styled.div`
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 32px;
    `;



export const StyledPhoneImageModified = styled(StyledPhoneImage)`
        margin-top: 0px;
    `;

export const StyledTextContainer = styled.div`
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        text-align: center;
    `;

export const StyledTitleText = styled.span`
        font-family: "Roboto Condensed";
        font-weight: 700;
        font-size: 24px;
        line-height: 28.13px;
        letter-spacing: 0;
        text-align: center;
        text-transform: uppercase;
        height: 100px;
    `;

export const StyledDescriptionText = styled.span`
        font-family: Roboto;
        font-weight: 400;
        font-size: 18px;
        line-height: 28px;
        letter-spacing: 0;
        text-align: center;
        opacity: 0.7;
    `;


export const StyledBadge = styled.span`
        position: absolute;
        right: 16px;
        top: 35%;
        left: 75%;
        transform: translateY(-50%);
        font-family: "Roboto Condensed";
        font-weight: 700;
        font-size: 64.68px;
        line-height: 75.8px;
        color: #dae753;
    `;

export const Ellipse = styled.div`
        background: #33835f;
        width: 230px;
        height: 226px;
        border-radius: 50%;
        position: relative;
    `;

export const StyledButton = styled.button`
        width: 90%;
        max-width: 352px;
        height: 51px;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        border-radius: 4px;
        padding: 16px 8px;
        background-color: ${props => props.buttonActive ? "#dae753" : "#008247"};
        color: ${props => props.buttonActive ? "#006437" : "#dae753"};
        border: none;
        cursor: pointer;
        bottom: 16px;
        @media (max-width: 900px) {
        width: 100%;
        }
    `;

export const StyledButtonText = styled.span`
        font-family: "Roboto Condensed";
        font-weight: 700;
        font-size: 16px;
        line-height: 18.75px;
        letter-spacing: 0%;
        text-align: center;
        text-transform: uppercase;
    `;

export const StyledPlanLink = styled.span`
        font-family: "Roboto Condensed";
        font-weight: 500;
        font-size: 16px;
        line-height: 18.75px;
        letter-spacing: 0%;
        text-align: center;
        text-decoration: underline;
        text-decoration-style: solid;
        text-decoration-offset: auto;
        text-decoration-thickness: auto;
        text-decoration-skip-ink: auto;
        text-transform: uppercase;
        color: #dae753;
        margin: 16px 16px;
        cursor: pointer;
    `;

export const CalendarContainer = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  padding: 16px;
  justify-content: center;
  align-items: center;
  @media (max-width: 900px) {
  height: auto;
  }
`;

export const CalendarImageWrapper = styled.div`
  position: relative;
`;

export const CalendarImg = styled.img`
  width: 139px;
  height: 159px;
`;

export const CalendarAvantiIconImg = styled.img`
  position: absolute;
  top: 60%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 114px;
  height: 36px;
`;